export default function (instance) {
  instance._reCalcCalendarDays = function (startDate, endDate, direction) {
    let tempHours = [];
    let workHoursInDay = 0;
    const tempStartDay = new Date(startDate);
    const oneDay = 24 * 60 * 60 * 1000;
    let calendarDays = '';

    tempHours = instance.getWorkHours(new Date(startDate));
    tempStartDay.setHours(tempHours[0]);
    workHoursInDay = instance.getDefaultWorkHoursPerDay(tempHours);

    if (startDate < tempStartDay) {
      startDate = tempStartDay;
    }
    calendarDays = direction * Math.abs(new Date(endDate).getTime() - new Date(startDate).getTime()) / oneDay;

    if (Math.round(calendarDays % 1 * 100) / 100 !== 0) {
      if (Math.round(1 / (24 / workHoursInDay) * 100) / 100 === Math.round((calendarDays % 1) * 100) / 100) {
        calendarDays = parseInt(calendarDays, 10) + 1;
      }
    }

    return Math.round(calendarDays * 100) / 100;
  };

  instance._reCalcDurationToMonth = function (startDate, endDate, gantt_id) {
    let calcDay = new Date(startDate.getFullYear(), startDate.getMonth(), 0);
    let calcMounth = 0;
    let controlDay = new Date(endDate);
    let countDaysInMounth = 0;
    let calcDuration = 0;
    const totalWeeks = instance._reCalcDurationToWeek(startDate, endDate, gantt_id);

    if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
      calcDay = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      controlDay = new Date(startDate);
    }
    while (calcDay < controlDay) {
      countDaysInMounth += new Date(calcDay.getFullYear(), calcDay.getMonth(), 0).getDate();
      calcDay.setMonth(calcDay.getMonth() + 1);
      calcMounth++;
    }
    if (!countDaysInMounth) {
      countDaysInMounth = calcDay.getDate();
      calcMounth = 1;
    }
    calcDuration = Math.round((totalWeeks.duration / ((countDaysInMounth / calcMounth) / 7)) * 100) / 100;
    calcDuration = !isNaN(calcDuration) ? calcDuration : '0';

    return { duration: calcDuration, calendarDays: totalWeeks.calendarDays };
  };

  instance._reCalcDurationToWeek = function (startDate, endDate, gantt_id) {
    const durationUnit = instance.calculateDuration(startDate, endDate, { calendar_id: gantt_id });
    let calcDay = new Date(startDate);
    const calendarDays = 0;
    let calcDuration = 0;
    let calcTotalDaysInWeek = 0;
    let controlDay = new Date(startDate);
    const oneWeek = 24 * 60 * 60 * 1000 * 7;
    const direction = 1;
    const totalDays = instance._reCalcDurationToDay(startDate, endDate);
    let calcTestWeekDays = 7;

    if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
      calcDay = new Date(endDate);
      controlDay = new Date(endDate);
    }
    while ((calcDay.getTime() - controlDay.getTime()) / oneWeek < 1 && calcTestWeekDays > 0) {
      if (instance.getWorkHours(calcDay).length) {
        calcTotalDaysInWeek++;
      }
      calcDay.setDate(calcDay.getDate() + 1);
      calcTestWeekDays -= 1;
    }
    calcDuration = Math.round((totalDays.duration / calcTotalDaysInWeek) * 100) / 100;
    calcDuration = !isNaN(calcDuration) ? calcDuration : '0';

    return { duration: calcDuration, calendarDays: totalDays.calendarDays };
  };

  instance._reCalcDurationToDay = function (startDate, endDate, gantt_id) {
    let durationUnit = instance.calculateDuration(startDate, endDate, { calendar_id: gantt_id });
    let calcDay = new Date(startDate);
    const durationMultiplic = { hour: 1, minute: 60 };
    let calendarDays = 0;
    let tempHours = [];
    let calcDuration = 0;
    let totalHoursInDurationDays = 0;
    let direction = 1;
    let controlDay = new Date(endDate);
    let totalDays = 0;

    if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
      direction = -1;
      calcDay = new Date(endDate);
      controlDay = new Date(startDate);
      durationUnit = direction * instance.calculateDuration(endDate, startDate, { calendar_id: gantt_id });
    }

    while (calcDay.valueOf() <= controlDay.valueOf()) {
      tempHours = instance.getWorkHours(calcDay);
      totalHoursInDurationDays = instance.getDefaultWorkHoursPerDay(tempHours);

      if (tempHours.length) {
        totalDays++;
      }
      calcDay.setDate(calcDay.getDate() + 1);
    }
    calcDuration = Math.round((durationUnit * instance.config.duration_step / durationMultiplic[instance.config.duration_unit]) / (totalHoursInDurationDays / totalDays) * 100) / 100;
    calendarDays = instance._reCalcCalendarDays(startDate, endDate, direction);
    calcDuration = !isNaN(calcDuration) ? calcDuration : '0';

    return { duration: calcDuration, calendarDays: calendarDays || 0 };
  };

  instance._reCalcDurationToHour = function (startDate, endDate, gantt_id) {
    let durationUnit = instance.calculateDuration(startDate, endDate, { calendar_id: gantt_id });
    const durationMultiplic = { hour: 1, minute: 60 };
    let calendarDays = 0;
    let direction = 1;
    let calcDuration = 0;

    if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
      direction = -1;
      durationUnit = direction * instance.calculateDuration(endDate, startDate, { calendar_id: gantt_id });
    }
    calendarDays = instance._reCalcCalendarDays(startDate, endDate, direction);

    calcDuration = Math.round((durationUnit * instance.config.duration_step / durationMultiplic[instance.config.duration_unit]) * 100) / 100;

    calcDuration = (!isNaN(calcDuration) || calcDuration < 0) ? calcDuration : '0';

    return { duration: calcDuration || 0, calendarDays: calendarDays || 0 };
  };

  instance._reCalcHourToDuration = function (startDate, newDuration) {
    const calcDay = new Date(startDate);
    let direction = 1;
    const durationMultiplic = { hour: 1, minute: 60 };
    const calcManualDuration = parseFloat(parseFloat(newDuration) * durationMultiplic[instance.config.duration_unit] / instance.config.duration_step);
    const endDate = instance.calculateEndDate(new Date(startDate), calcManualDuration * durationMultiplic.minute, 'minute');
    let calendarDays = 0;

    if (newDuration < 0) {
      direction = -1;
    }
    calendarDays = instance._reCalcCalendarDays(startDate, endDate, direction);

    return { endDate, calendarDays };
  };

  instance._reCalcMinuteToDuration = function (startDate, newDuration) {
    const calcDay = new Date(startDate);
    let direction = 1;
    const calcManualDuration = parseFloat(parseFloat(newDuration) / instance.config.duration_step);
    const endDate = instance.calculateEndDate(new Date(startDate), calcManualDuration, 'minute');
    let calendarDays = 0;

    if (newDuration < 0) {
      direction = -1;
    }

    calendarDays = instance._reCalcCalendarDays(startDate, endDate, direction);

    return { endDate, calendarDays };
  };

  instance._reCalcDaysToDuration = function (startDate, newDuration) {
    const calcDay = new Date(startDate);
    const durationMultiplic = { hour: 1, minute: 60 };
    let endDate = {};
    let tempHours = [];
    let calcTotalDays = 0;
    let calcManualDuration = 0;
    let direction = 1; // if 0 then forward if - 1 then backward
    const floatDays = newDuration.toString().split('.');
    let floatDaysAbs = 0;
    var i = 0;
    let floatHours = 0;
    let calendarDays = 0;

    if (floatDays[0] < 0) {
      direction = -1;
    }
    floatDaysAbs = Math.abs(floatDays[0]);

    while (calcTotalDays < floatDaysAbs) {
      tempHours = instance.getWorkHours(calcDay);

      if (typeof tempHours[0] === 'string') {
        tempHours = tempHours.map(i => i.split('-')).flat(2).map(i => {
          const hours = i.split(':');
          let res = Number(hours[0]);
          if (Number(hours[1])) {
            res += 0.5;
          }
          return res;
        });
      }

      for (i = 0; i < tempHours.length; i += 2) {
        calcManualDuration += (tempHours[i + 1] - tempHours[i]) * durationMultiplic[instance.config.duration_unit] / instance.config.duration_step;
      }

      if (tempHours.length) {
        calcTotalDays++;
      }
      calcDay.setDate(calcDay.getDate() + direction);
    }

    if (!tempHours.length) {
      tempHours = instance.getWorkHours(instance.getClosestWorkTime(calcDay));
    }

    if (floatDays[1]) {
      var workHoursCount = instance.getDefaultWorkHoursPerDay(tempHours);

      floatHours = parseFloat(floatDays[1] / Math.pow(10, floatDays[1].length) * workHoursCount).toFixed(2).toString().split('.');

      calcManualDuration += parseInt(floatHours[0]) * durationMultiplic[instance.config.duration_unit] / instance.config.duration_step;
      if (floatHours[1]) {
        const range = Math.pow(10, floatHours[1].length) * instance.config.duration_step;
        const roundHours = floatHours[1] * durationMultiplic[instance.config.duration_unit] / range;

        calcManualDuration += Math.round(roundHours * range / range);
      }
    }
    endDate = instance.calculateEndDate(new Date(startDate), direction * calcManualDuration, instance.config.duration_unit);
    calendarDays = instance._reCalcCalendarDays(startDate, endDate, direction);

    return { endDate, calendarDays };
  };

  instance._reCalcWeeksToDuration = function (startDate, newDuration) {
    const calcDay = new Date(startDate);
    const floatWeeks = newDuration.toString().split('.');
    let calcTotalDaysInWeek = 0;
    let direction = 1;
    let totalDays = 0;

    if (floatWeeks[0] < 0) {
      direction = -1;
    }

    while (Math.abs((calcDay.getTime() - new Date(startDate).getTime()) / (24 * 60 * 60 * 1000 * 7)) < 1) {
      if (instance.getWorkHours(calcDay).length) {
        calcTotalDaysInWeek++;
      }
      calcDay.setDate(calcDay.getDate() + direction);
    }
    totalDays = parseInt(calcTotalDaysInWeek * Math.abs(floatWeeks[0]), 10);

    if (floatWeeks[1]) {
      totalDays += parseFloat(Math.round(floatWeeks[1] / Math.pow(10, floatWeeks[1].length) * calcTotalDaysInWeek * 100) / 100);
    }

    return instance._reCalcDaysToDuration(startDate, (direction * totalDays).toString());
  };

  instance._reCalcMonthToDuration = function (startDate, newDuration) {
    const calcDay = new Date(startDate.getFullYear(), startDate.getMonth(), 0);
    let countDaysInMounth = 0;
    const floatMount = newDuration.toString().split('.');
    let direction = 1;
    let calcMounth = 0;

    if (floatMount[0] < 0) {
      direction = -1;
    }
    while (calcMounth < Math.abs(floatMount[0])) {
      if (direction < 0) {
        countDaysInMounth += new Date(calcDay.getFullYear(), calcDay.getMonth() - 1, 0).getDate();
      } else {
        countDaysInMounth += new Date(calcDay.getFullYear(), calcDay.getMonth(), 0).getDate();
      }

      calcDay.setMonth(calcDay.getMonth() + direction);
      calcMounth++;
    }

    if (floatMount[1] && !countDaysInMounth) {
      countDaysInMounth = calcDay.getDate();
      calcMounth = 1;
    }

    return instance._reCalcWeeksToDuration(startDate, Math.round((countDaysInMounth / calcMounth) * newDuration / 7 * 100) / 100);
  };

  instance._reCalcYearToDuration = function (startDate, newDuration) {
    return instance._reCalcMonthToDuration(startDate, newDuration * 12);
  };

  instance._reCalcQuarterToDuration = function (startDate, newDuration) {
    return instance._reCalcMonthToDuration(startDate, newDuration * 3);
  };

  instance.calculateDurationTo = function (startDate, endDate, durationView, gantt_id) {
    const strategy = {
      month: instance._reCalcDurationToMonth,
      week: instance._reCalcDurationToWeek,
      day: instance._reCalcDurationToDay,
      hour: instance._reCalcDurationToHour,
      minute: instance._reCalcMinuteToDuration,
    };

    return strategy[durationView || instance.config.duration_view || 'hour'](startDate, endDate, gantt_id);
  };

  instance.calculateToDuration = function (startDate, newDuration, durationView) {
    switch (durationView || instance.config.duration_view) {
    case 'year':
      return instance._reCalcYearToDuration(startDate, newDuration);
    case 'quarter':
      return instance._reCalcQuarterToDuration(startDate, newDuration);
    case 'month':
      return instance._reCalcMonthToDuration(startDate, newDuration);
    case 'week':
      return instance._reCalcWeeksToDuration(startDate, newDuration);
    case 'day':
      return instance._reCalcDaysToDuration(startDate, newDuration);
    case 'hour':
      return instance._reCalcHourToDuration(startDate, newDuration);
    case 'minute':
      return instance._reCalcMinuteToDuration(startDate, newDuration);
    }
  };
}
